
export function not_empty(txt) {
    return !(txt === null || String(txt).trim() === '' || txt === undefined);
}

export function is_empty(txt) {
    return !not_empty(txt);

}

export function is_time(txt) {
    var patron = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
    return patron.test(txt);

}

export function is_integer(txt) {
    var patron = /^[0-9]+$/;
    return patron.test(txt);
}

export function is_decimal(txt) {
    var patron = /^-?\d*(\.\d+)?$/;
    return patron.test(txt);
}

// noinspection JSUnusedGlobalSymbols
export function only_text(txt) {
    var patron = /^[A-Za-z\s]+$/;
    return patron.test(txt);
}

// noinspection JSUnusedGlobalSymbols
export function valid_IP(txt) {
    let pattern = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;
    return pattern.test(txt);
}

export function is_email(txt) {
    //eslint-disable-next-line
    let pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;
    return pattern.test(txt);
}
export function isGreaterThan(a, b) {
    return parseInt(a) > parseInt(b);
}

export function minLength(txt, size) {
    return txt.length >= size;
}
export function maxValueInteger(value, max) {
    return value <= max;
}

export function validPassword(txt) {
    let pattern = /^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,100}$/
    return pattern.test(txt);
}



export function isValidPassword(txt) {
    let pattern=/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return pattern.test(txt);
}


